import { useEffect } from 'react';
import i18next from 'i18next';

const useMountWithTranslate = (callbackFunction, deps = []) => useEffect(callbackFunction, [i18next.language, ...deps]);

export default useMountWithTranslate;
